import { createFileRoute, redirect } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../components/shared/page-components/LoadingPage';
import { PENDING_LINK_QUERY } from '../../data/apollo/queries';

type EmailVerifiedSearch = {
  appPath?: String;
};

export const Route = createFileRoute('/_authenticated/email-verified')({
  component: () => <LoadingPage loadingApplication />,
  validateSearch: (search: Record<string, unknown>): EmailVerifiedSearch => ({
    appPath: search.appPath as String,
  }),
  beforeLoad: async ({
    context,
  }: {
    context: { auth0: any; apolloClient: any };
  }) => {
    const { auth0, apolloClient } = context;
    let emailVerified = auth0?.user?.email_verified;

    if (auth0?.user && !emailVerified) {
      // refresh token to double check email is verified or not
      await auth0.getAccessTokenSilently({ cacheMode: 'off' });
      const idTokenClaims = await auth0.getIdTokenClaims();

      emailVerified = idTokenClaims?.email_verified;
    }

    if (emailVerified) {
      const { data: { checkPendingLinkCodeInvite } = {} } =
        await apolloClient.query({
          query: PENDING_LINK_QUERY,
          variables: {
            email: auth0?.user?.email,
          },
          fetchPolicy: 'network-only',
        });

      if (checkPendingLinkCodeInvite?.hasPendingLink) {
        throw redirect({
          to: '/settings/general',
          search: {
            codeInviteToken: checkPendingLinkCodeInvite.codeInviteToken,
          },
        });
      }

      throw redirect({
        to: '/',
        replace: true,
      });
    } else {
      throw redirect({ to: '/verify-email', replace: true });
    }
  },
});
